import { LOCALISE_LANGUAGE_FIELD_NAME, PARENT_FIELD } from '@pkg/config/sanity/constants';
import { slugWithParents } from '@pkg/sanity-utils/slugWithParents';
import { authorHasBioForLocale } from '@pkg/sanity-utils/authorBioQueries';
import { translatedFieldQuery } from '@pkg/sanity-utils/translatedFieldQuery';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

/** `_translations` (hreflang) leaves out hidden posts; see `shallowPageFields`. */
export const postFields = groq`
  _type,
  ${slugWithParents},
  ${PARENT_FIELD},
  ${LOCALISE_LANGUAGE_FIELD_NAME},
  pageVisibility,
  seoSocial,
  hideHeader,
  "_translations": (*[_type == "translation.metadata" && references(^._id)].translations[].value->)[pageVisibility != "hidden"]{
    title,
    "slug": slug.current,
    language
  },
  _createdAt,
  _updatedAt,
  publishedAt,
  updatedAt,
  pretitle,
  title,
  excerpt,
  author->{
    name,
    slug,
    ${translatedFieldQuery('jobTitle')},
    image,
    "hasBio": ${authorHasBioForLocale},
  },
  slug,
  parent,
  image,
  content[] {
    ${portableTextWithReferences}
  },
  migrated,
  contentChoice,
  pageContent,
  categories
`;
